<template>
    <div class="card">
        <div class="table-responsive"  style="min-height: 400px">
            <table class="table">
                <thead>
                <tr>
                  <th>SL</th>
                  <th>Customer Details</th>
                  <th>Order Number</th>
                  <th>Order Date</th>
                  <th class="text-right">Order Amount</th>
                  <th>Invoice No</th>
                  <th>Invoice Date</th>
                  <th>Invoice Amount</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in purchase.data" :key="i">
                    <td class="text-center"> {{ (purchase.current_page - 1) * (purchase.per_page) + (i + 1) }}</td>
                    <td> {{ item.party_name }} ({{ item.contact.company_roles && item.contact.company_roles[0] ? item.contact.company_roles[0].pivot.serial_no : ''}})</td>
                    <td>
                        <button @click="printPreInvoice(item)" class="btn btn-outline-success btn-sm mr-5">
                          <span>{{ item.bill_number }}</span>
                        </button>
                        <button v-if="!item.sale_master_id" class="btn btn-outline-primary btn-sm"
                                @click="goToEdit(item.id)"
                                style="cursor: pointer"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </button>
                        <button v-if="!item.sale_master_id && item.status === 'active'" class="btn btn-outline-danger btn-sm ml-5"
                            @click="updateStatus(item.id, 'cancelled')"
                        >
                            <i class="fa fa-trash"></i>
                        </button>
                        <button v-if="!item.sale_master_id && item.status === 'cancelled'" class="btn btn-outline-success btn-sm ml-5"
                            @click="updateStatus(item.id, 'active')"
                        >
                            Active
                        </button>
                    </td>
                    <td> {{ item.date }}</td>
                    <td class="text-right"> {{ item.bill_amount }}</td>
                    <td class="text-right">
                      <span v-if="item.sale_master_id">{{ item.sale_master_bill_number }}</span>
                    </td>
                    <td class="text-right">
                      <span v-if="item.sale_master_id">{{ item.sale_master_date }}</span>
                    </td>
                    <td class="text-right">
                      <span v-if="item.sale_master_id">{{ item.sale_master_total_amount }}</span>
                    </td>
                    <td>
                        <div class="btn-group">
                            <div v-if="item.status != 'cancelled'">
                                <button @click="goToInvoice(item)" title v-if="!item.sale_master_id" class="btn btn-outline-primary btn-sm  ">
                                    <i class="fas fa-plus"></i>
                                    Invoice
                                </button>
                                <div class="btn-group" v-if="item.sale_master_id" >
                                  <button type="button" class="btn   dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                  </button>
                                  <div class="dropdown-menu dropdown-menu-end">
                                    <a v-if="item.sale_master_id" @click="goToPrint(item.sale_master_id,1)" class="dropdown-item" href="#">Print Invoice</a>
                                    <a v-if="item.sale_master_id" @click="goToPrint(item.sale_master_id,2)" class="dropdown-item" href="#">Print Delivery Challan</a>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>

                </tbody>
            </table>
            <p v-if="purchase && purchase.data && !purchase.data.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script>
import { inject } from 'vue';
import figureFormatter from '@/services/utils/figureFormatter';
import handlePurchase from "@/services/modules/purchase";
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleCompany from "@/services/modules/company";
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import { formatDate } from '@/services/utils/global';
import handleHospital from '@/services/modules/hospital'

export default {  
    name: 'PurchaseListTable',
    data() {
        return{
            companyInfo: {},
            invoice: {},
            barcodeQuery: '',
            barcode: '',
            user: {},
            qrcode: '',
            invoiceNotes: [],
            customizationPdfFields: [],
            singleSalesOrder: {}
        }
    },
    props: {
        purchase: Object,
        route_name: {
            type: String,
            default: 'purchase-bill-edit'
        },
        fromApproval: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const {commaFormat} = figureFormatter()
        const { fetchSalesBill, fetchSalesOrderById, updateOrderStatus } = handlePurchase();
        const { fetchCompanyInfo, fetchActiveCustomizationField } = handleCompany();
        const { exportToPDF } = pdfPrinter();
        const { fetchBarcode } = handleBarcode();
        const store = useStore();
        const { notesByType } = handleHospital()
        const showError = inject('showError');
        const showSuccess = inject('showSuccess');

        return {
            commaFormat,
            fetchSalesBill,
            fetchSalesOrderById,
            exportToPDF,
            fetchCompanyInfo,
            fetchActiveCustomizationField,
            fetchBarcode,
            store,
            notesByType,
            updateOrderStatus,
            showError,
            showSuccess
        }
    },
    mounted() {
         this.fetchCompanyInfo(this.$route.params.companyId).then( (res) => {
            this.companyInfo = res.data;
         }).catch((error) => {
            console.log(error);
         });

         this.getInvoiceNotes();
         this.getActiveFiledCustomization();

         this.user = this.store.state.user.user
    },
    methods: {
        async getInvoiceNotes () {
            const companyQuery = `?company_id=${this.$route.params.companyId}&show_default_only=1`;
            await this.notesByType(companyQuery, "invoice_terms").then((res) => {
                if(! res.status) return;
                this.invoiceNotes = res.data.filter((item) => item.full_desc);
            })
        },

        async getActiveFiledCustomization ()  {
          const companyQuery = `?company_id=${this.$route.params.companyId}&customization_type=pdf&type=sale_invoice_pdf_list`;
          await this.fetchActiveCustomizationField(companyQuery).then((res) => {
            this.customizationPdfFields = res.data;
          })
        },

        async printPreInvoice(item) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            await this.fetchSalesOrderById(item.id, companyQuery).then(async (res) => {
                if(! res.data) return;

                this.singleSalesOrder = res.data

                let qrcodeData = JSON.stringify({
                    ref_no: this.singleSalesOrder.bill_number,
                    ref_date: this.singleSalesOrder.date,
                    created_by: this.singleSalesOrder.created_by_name,
                    created_date_time: formatDate(new Date())
                })

                this.barcodeQuery = `?code=${this.singleSalesOrder.bill_number}&qrcode=${qrcodeData}`;

                await this.fetchBarcode(this.barcodeQuery).then( (res) => {
                    if(res.status){
                        this.qrcode = res.qrcode
                        this.exportToPDF(this.companyInfo, this.singleSalesOrder, this.barcode, this.qrcode, this.user.name, 1, this.invoiceNotes, true)
                    }
                })
            })
            .catch( (err) => {
                console.log("Something went wrong");
            })
        },
        async goToPrint(id,btnFunc) {

            const companyQuery = `?company_id=${this.$route.params.companyId}`;

            await this.fetchSalesBill(id, companyQuery).then( async (res) =>{

                    if(! res.status) return;
                    this.invoice = res.data;

                    let qrcodeData = JSON.stringify({
                        ref_no: this.invoice.bill_number,
                        ref_date: this.invoice.date,
                        created_by: this.invoice.created_by_name,
                        created_date_time: formatDate(new Date())
                    })

                    this.barcodeQuery = `?code=${this.invoice.bill_number}&qrcode=${qrcodeData}`;

                    await this.fetchBarcode(this.barcodeQuery).then( (res) => {
                        if(res.status){
                            this.barcode = res.barcode;
                            this.qrcode = res.qrcode
                            this.exportToPDF(this.companyInfo, this.invoice, this.barcode, this.qrcode, this.user.name, btnFunc, this.invoiceNotes, true, this.customizationPdfFields)
                        }
                    })

                }).catch( (err) => {
                    console.log("Something went wrong");
                })
        },
        goToInvoice(item) {
            this.$router.push({
                name: 'sales-invoice-add',
                params: this.$route.params,
                query: {
                    start: this.$route.query.start,
                    end: this.$route.query.end,
                    sales_order_id: item.id,
                    redirect_route: 'order-sales'
                }
            })
        },
        goToEdit(id) {
            let dynamicKeyName = (this.route_name === 'purchase-bill-edit') ? 'purchaseId' : 'salesId'
            let param = {
              companyId: this.$route.params.companyId,
              moduleId: this.$route.params.moduleId,
              menuId: this.$route.params.menuId,
              pageId: this.$route.params.pageId,
            }
            param[dynamicKeyName] = id;

            const query = this.$route.query;
            if(this.$route.name === 'sales-order-approval'){
                query.type = 'approval';
            }else if(this.$route.name === 'order-sales'){
               query.type = 'order-sales';
            }

            this.$router.push({
                name: this.route_name,
                params: param,
                query: query
            })
        },
        async updateStatus(id, status) {
            const actionText = status === 'cancelled' ? 'cancel' : 'activate';
            if (! confirm(`Are you sure you want to ${actionText} this order?`)) return;

            const companyQuery = `?company_id=${this.$route.params.companyId}&status=${status}`;

            await this.updateOrderStatus(companyQuery, id).then( async (res) => {
                if(! res.status) {
                    this.showError(res.message);
                    return;
                };
                this.showSuccess(res.message);
                this.$emit('orderStatusChanged');
            }).catch( (err) => {
                console.log("Something went wrong");
            })
        }
    }
}
</script>

<style scoped>
.btn-challan {
    background-color: #249024 !important;
}
.ml-5 {
    margin-left: 5px;
}
</style> 